import type { InjectionKey, Ref } from 'vue';

export type UiRadioGroupContext = {
  modelValue: Ref<unknown>;
  disabled: Ref<boolean>;
  color: Ref<string | undefined>;
  styleType: Ref<string>;
  setModelValue: (value: unknown) => void;
};

export const uiRadioGroupContextKey: InjectionKey<UiRadioGroupContext> = Symbol('uiRadioGroupContext');
